import React, { Component } from 'react';
import autoBind from 'react-autobind';
import TableHelper from 'src/utils/table-helper';
import CustomFeeMap from 'src/components/maps/custom-fee-map';
import { withTranslation } from 'react-i18next';
import { Entities } from 'src/common';
import AdminGeofenceAreaItems from 'src/components/admin/geofence-areas/components/geofence-area-items';

class AdminAdditionalFeesAreaAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();

        this.state = {
            startedFetching: false,
            googleReady: false,
            hoveredGeofence: null,
            editGeofence: null,
        };
    }

    handleGeofenceHover = geofenceItem => {
        this.setState({ hoveredGeofence: geofenceItem });
    };

    componentDidMount() {
        this.waitForGoogle();
        this.props.fetchAll(Entities.BUS_COMPANY);
        this.props.search(Entities.GEOFENCE_AREA, `get-all`, 0, undefined, true);
    }

    waitForGoogle() {
        if (window.google && window.google.maps) {
            this.setState({ googleReady: true });
            return;
        }
        this.pollGoogle();
    }

    pollGoogle() {
        const interval = setInterval(() => {
            if (window.google && window.google.maps) {
                clearInterval(interval);
                this.setState({ googleReady: true });
            }
        }, 100);
    }

    setGeoFenceForEdit = geofence => {
        this.setState({ editGeofence: geofence });
    };

    removeGeofenceForEdit() {
        this.setState({ editGeofence: null });
    }

    render() {
        const { t } = this.props;
        if (!this.state.googleReady) {
            return <div>{t('common_phrases.loading')}</div>;
        }
        return (
            <div className="col-md-12">
                <CustomFeeMap
                    containerElement={<div style={{ height: '500px' }} />}
                    mapElement={<div className="col-md-8" style={{ height: '100%' }} />}
                    onPolygonComplete={coords => console.log(coords)}
                    busCompanies={this.props.busCompanies.items}
                    maxPoints={16}
                    activeGeofence={this.state.hoveredGeofence}
                    t={t}
                    addNotification={this.props.addNotification}
                    addErrorNotification={this.props.addErrorNotification}
                    search={this.props.search}
                    editGeofence={this.state.editGeofence}
                    removeGeofenceForEdit={this.removeGeofenceForEdit}
                />

                <AdminGeofenceAreaItems
                    geofenceAreas={this.props.geofenceAreas}
                    onHoverArea={this.handleGeofenceHover}
                    deleteGeoFenceArea={this.props.deleteGeoFenceArea}
                    search={this.props.search}
                    addNotification={this.props.addNotification}
                    setGeoFenceForEdit={this.setGeoFenceForEdit}
                    editGeofence={this.state.editGeofence}
                />
            </div>
        );
    }
}

export default withTranslation()(AdminAdditionalFeesAreaAdministration);
